// Saved Auflagen values retain their compact form; display each side on its own line.
export function formatAuflagenValue(item, rawValue = item?.value) {
  if (String(item?.name || '').trim().toLowerCase() !== 'auflagen' || typeof rawValue !== 'string') {
    return null;
  }

  const values = new Map();
  const parts = rawValue.split(/\s*\/\s*|[\r\n]+/).map(part => part.trim()).filter(Boolean);
  for (const part of parts) {
    const match = part.match(/^(?:Auflage\s+)?(links|rechts|oben|unten)\s*:\s*(-?\d+(?:[.,]\d+)?)\s*mm$/i);
    if (!match || values.has(match[1].toLowerCase())) return null;
    values.set(match[1].toLowerCase(), match[2]);
  }
  if (values.size !== 4) return null;

  return ['links', 'rechts', 'oben', 'unten']
    .map(side => `Auflage ${side}: ${values.get(side)} mm`).join('\n');
}

// ZAM values share a saved step with RAM/wing dimensions in the PG-400 templates.
export function expandDimensionItems(items = []) {
  return items.flatMap(item => {
    const dimensions = [item?.zamWidthValue, item?.zamHeightValue]
      .map(value => String(value ?? '').replace(/mm/ig, '').replace(/,/g, '.').trim());

    if (dimensions.some(value => value === '')) {
      return [item];
    }

    return [
      {
        id: `${item.id}-zam`,
        name: 'ZAM Maß',
        value: dimensions.map(value => `${value}mm`).join(' x '),
      },
      item,
    ];
  });
}
